import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap";
import NewsCard from "../NewsCard";
import Slider from "react-slick";

import {LatestNews} from "../../common/queries/common_use_query"
import "./News.scss";


const News = ({Module}) => {

    //const{loading, error, data} = LatestNews();

    const data = useStaticQuery(graphql`
      query LatestNewsQuery{
        glstrapi {
            blogs(sort:"createdAt:desc", where:{publish:true}, limit:12){
                id
                title
                slug
                embed_video_url
                tile_image{
                  url
                  alternativeText
                }
                tags
                imagetransforms
            }

            community_blogs:blogs(sort:"createdAt:desc", where:{publish:true, categories:"Communities"}, limit:12){
                id
                title
                slug
                embed_video_url
                tile_image{
                  url
                  alternativeText
                }
                tags
                imagetransforms
            }
        }
    }`)

    var blogs = Module?.select_type === "community" ? data.glstrapi?.community_blogs : data.glstrapi?.blogs;

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    const [icon, setIcon] = useState(false);

    return (
        <>
            <section className={icon ? "new-news" : "news"}>
                <Container>
                    <Row>
                        <Col>
                            <h2>{(Module?.Title) ? Module.Title : 'News & Insights'}</h2>

                            {blogs?.length > 0 && 
                                <Slider {...settings}>
                                    {blogs?.map((News, index) => (
                                        <NewsCard key={index} NewsList={News} />
                                    ))}
                                </Slider>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default News;